import { Component, computed, input } from '@angular/core';
import { UIIconComponent, UiNumberComponent } from '@design-system';
import { OrderFormHeaderSymbol } from '../../models/order-form-header.model';

@Component({
	selector: 'app-order-form-header',
	templateUrl: './order-form-header.component.html',
	imports: [UiNumberComponent, UIIconComponent]
})
export class OrderFormHeaderComponent {
	readonly symbol = input.required<OrderFormHeaderSymbol>();

	readonly lastPriceUp = computed(() => this.symbol().lastPriceChangePercent >= 0);
	/** An unchanged price paints its percentage neutral; the change amount keeps its colour. */
	readonly lastPriceUnchanged = computed(() => this.symbol().lastPriceChangePercent === 0);
}
